import React, { useState, useRef, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Container, Row, Col, Button, FormGroup, Label, Input,
  Modal, ModalHeader, ModalBody, ModalFooter,
} from "reactstrap";
import axios from "axios";
import html2canvas from "html2canvas";
import "./regisration.css";

const validationSchema = Yup.object().shape({
  kategori: Yup.string().required("Wajib diisi"),
  namaTim: Yup.string().required("Wajib diisi"),
  universitas: Yup.string().required("Wajib diisi"),
  peran: Yup.string().required("Wajib diisi"),
  namaLengkap: Yup.string().required("Wajib diisi"),
  gender: Yup.string().required("Wajib diisi"),
  email: Yup.string().email("Email tidak valid").required("Wajib diisi"),
  hp: Yup.string()
    .matches(/^\+?[0-9]{10,15}$/, "Format nomor HP tidak valid")
    .required("Wajib diisi"),
});

const QR_API = data =>
  `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(data)}`;

const Registration = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("confirm");
  const [formValues, setFormValues] = useState(null);

  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const idCardRef = useRef(null);

  const [isEmailSending, setIsEmailSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const [isCheckingHP, setIsCheckingHP] = useState(false);

  const sanitizePhone = hp => {
    if (!hp) return hp;
    let cleaned = hp.replace(/\D/g, "");
    if (cleaned.startsWith("0")) cleaned = "62" + cleaned.substring(1);
    return cleaned;
  };

  const handleConfirmOpen = async values => {
    setIsCheckingHP(true); // ✅ Tampilkan spinner saat cek ke API
    const hpSanitized = sanitizePhone(values.hp);

    try {
      const res = await axios.post(
        "https://tiket.rlagency.id/api/check-duplicate-hp.php",
        { hp: hpSanitized },
        { headers: { "Content-Type": "application/json" } }
      );

      if (res.data?.exists) {
        setModalType("duplicate");
        setFormValues(res.data.data);
      } else {
        setModalType("confirm");
        setFormValues({ ...values, hp: hpSanitized });
      }

      setIsModalOpen(true);

    } catch (err) {
      alert("Gagal cek nomor HP.");
      console.log(err);
    } finally {
    setIsCheckingHP(false); // ✅ Sembunyikan spinner setelah modal muncul
  }
  };

  const submitToAPI = async () => {
    setIsSubmitting(true);
    setIsModalOpen(false);

    try {
      const res = await axios.post(
        "https://tiket.rlagency.id/api/register-peserta.php",
        formValues,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!res.data?.success) {
        alert("Registrasi gagal.");
        return;
      }

      setSuccessData({
        namaLengkap: formValues.namaLengkap,
        namaTim: formValues.namaTim,
        email: formValues.email,
        hp: formValues.hp,
        qr_code: res.data.qr_code,
        secret_code: res.data.secret_code,
        peserta_id: res.data.peserta_id,
      });

      setIsSuccessOpen(true);
      setEmailSent(false);

    } catch (err) {
      alert("Gagal mengirim data.");
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isSuccessOpen && successData && !emailSent) {
      setTimeout(async () => {
        try {
        //   const canvas = await html2canvas(idCardRef.current, { scale: 2 });
          const canvas = await html2canvas(idCardRef.current, {
            scale: 2,
            useCORS: true,
          });
          const imgBase64 = canvas.toDataURL("image/jpeg", 0.95);

          const safeTeam = successData.namaTim.replace(/\s+/g, "_");
          const safeHp = successData.hp.replace(/\D/g, "");
          const filename = `IDCard_${safeTeam}_${safeHp}.jpg`;

          setIsEmailSending(true);

          const response = await axios.post(
            "https://tiket.rlagency.id/api/regis-email.php",
            {
              ...successData,
              filename,
              image_base64: imgBase64,
            },
            { headers: { "Content-Type": "application/json" } }
          );

          setIsEmailSending(false);
          setEmailSent(true);

          if (!response.data.success) {
            alert("Email gagal dikirim, tapi registrasi sukses.");
          }

        } catch (err) {
          setIsEmailSending(false);
          alert("Kesalahan saat mengirim ID Card via email.");
        }
      }, 800);
    }
  }, [isSuccessOpen, successData, emailSent]);

  const downloadIdCard = async () => {
    // const canvas = await html2canvas(idCardRef.current, { scale: 2 });
    const canvas = await html2canvas(idCardRef.current, {
        scale: 2,
        useCORS: true,
    });
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/jpeg", 1);
    a.download = `IDCard_${successData.namaTim}_${successData.hp}.jpg`;
    a.click();
  };

  return (
    <Container className="apple-container fade-in">
      <div className="apple-card">

        <header className="header-section">
          <h3>FORM REGISTRASI ULANG WELCOMING DINNER PESERTA ENTREPRENEURSHIP AWARD IX - 2025</h3>
          <p className="event-info">Inovasi, Kolaborasi, dan Dampak Nyata Kewirausahaan Mahasiswa Indonesia</p>
          <p className="event-info">5 - 6 November 2025 | Universitas Putra Indonesia YPTK Padang</p>
        </header>
        <hr/>
        <Formik
          initialValues={{
            kategori: "",
            namaTim: "",
            universitas: "",
            peran: "",
            namaLengkap: "",
            gender: "",
            email: "",
            hp: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleConfirmOpen}
        >
          {() => (
            <Form>
              {/* Form */}
              <div className="form-group-title">Data Tim</div>

              <FormGroup>
                <Label>Kategori Lomba<span className="required-star">*</span></Label>
                <Field as={Input} type="select" name="kategori">
                  <option value="">Pilih kategori</option>
                  <option value="Plan Bisnis">Plan Bisnis</option>
                  <option value="Bisnis Berjalan">Bisnis Berjalan</option>
                </Field>
                <ErrorMessage name="kategori" component="div" className="error" />
              </FormGroup>

              <FormGroup>
                <Label>Nama Tim<span className="required-star">*</span></Label>
                <Field as={Input} type="text" name="namaTim" />
                <ErrorMessage name="namaTim" component="div" className="error" />
              </FormGroup>

              <FormGroup>
                <Label>Asal Universitas<span className="required-star">*</span></Label>
                <Field as={Input} type="text" name="universitas" />
                <ErrorMessage name="universitas" component="div" className="error" />
              </FormGroup>

              <div className="form-group-title">Data Peserta</div>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Peran Dalam Tim<span className="required-star">*</span></Label>
                    <Field as={Input} type="select" name="peran">
                      <option value="">Pilih</option>
                      <option value="Ketua">Ketua</option>
                      <option value="Anggota">Anggota</option>
                      <option value="Dosen Pembimbing">Dosen Pembimbing</option>
                    </Field>
                    <ErrorMessage name="peran" component="div" className="error" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label>Jenis Kelamin<span className="required-star">*</span></Label>
                    <Field as={Input} type="select" name="gender">
                      <option value="">Pilih</option>
                      <option value="L">Laki Laki</option>
                      <option value="P">Perempuan</option>
                    </Field>
                    <ErrorMessage name="gender" component="div" className="error" />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup>
                <Label>Nama Lengkap<span className="required-star">*</span></Label>
                <Field as={Input} type="text" name="namaLengkap" />
                <ErrorMessage name="namaLengkap" component="div" className="error" />
              </FormGroup>

              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Label>Email Aktif<span className="required-star">*</span></Label>
                    <Field as={Input} type="email" name="email" />
                    <ErrorMessage name="email" component="div" className="error" />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <Label>No HP Aktif<span className="required-star">*</span></Label>
                    <Field as={Input} type="tel" name="hp" />
                    <ErrorMessage name="hp" component="div" className="error" />
                  </FormGroup>
                </Col>
              </Row>

              <Button type="submit" className="btn-submit" disabled={isSubmitting}>
                {isSubmitting ? "Mengirim..." : "Daftar Sekarang"}
              </Button>

              <div className="registration-note">
                    <p className="note-title">Note</p>
                    <ul>
                        <li>
                        Setelah mendaftar, Anda akan mendapatkan QR Code yang dikirimkan via <strong>Email</strong>. 
                        Pastikan email yang didaftarkan adalah <strong>email aktif</strong>.
                        </li>
                        <li>
                        QR Code digunakan sebagai <strong>Bukti Kehadiran</strong> saat Gala Dinner. Tunjukkan QR Code kepada panitia untuk discan.
                        </li>
                    </ul>
              </div>
              
            </Form>
          )}
        </Formik>

      </div>

      {/* Modal Confirm & Duplicate */}
      {formValues && (
        <Modal isOpen={isModalOpen} centered className="apple-modal">
          <ModalHeader>
            {modalType === "duplicate" ? "Pendaftaran Ditolak" : "Konfirmasi Data"}
          </ModalHeader>
          <ModalBody>
            {modalType === "duplicate" ? (
                <div className="duplicate-info">
                    <p className="duplicate-title">Anda sudah terdaftar dengan data berikut:</p>
                    <div className="duplicate-data">
                    <div><strong>Nama Tim:</strong> {formValues?.namaTim}</div>
                    <div><strong>Nama Lengkap:</strong> {formValues?.namaLengkap}</div>
                    <div><strong>Peran:</strong> {formValues?.peran}</div>
                    </div>
                    <p className="duplicate-note">
                    Jika ada kesalahan data, silakan hubungi panitia untuk perbaikan.
                    </p>
                </div>
                ) : (
                <p>Apakah Anda yakin untuk melanjutkan ?</p>
            )}
          </ModalBody>
          <ModalFooter className="apple-modal-footer">
            {modalType === "duplicate" ? (
                <Button className="btn-apple-confirm" onClick={() => setIsModalOpen(false)}>
                OK
                </Button>
            ) : (
                <>
                <Button className="btn-apple-cancel" onClick={() => setIsModalOpen(false)}>
                    Tidak
                </Button>
                <Button className="btn-apple-confirm" onClick={submitToAPI}>
                    Ya
                </Button>
                </>
            )}
          </ModalFooter>

        </Modal>
      )}

      {/* Modal Success */}
      <Modal isOpen={isSuccessOpen} centered className="apple-modal">
            <ModalHeader className="modal-header-clean">Download dan Simpan Barcode</ModalHeader>
            <ModalBody>
                <div ref={idCardRef} className="id-card-pro">
                <div className="qr-column">
                    {successData?.qr_code && (
                    <img
                        src={QR_API(successData.qr_code)}
                        alt="QR Code"
                        className="qr-img"
                        crossOrigin="anonymous"
                    />
                    )}
                </div>

                <div className="info-column">
                    <h4 className="event-title">Welcoming Dinner Entrepreneurship Award IX 2025</h4>
                    <p className="event-tagline">
                    Inovasi • Kolaborasi • Dampak Nyata Kewirausahaan Mahasiswa Indonesia
                    </p>
                    <p className="event-date">
                    5–6 November 2025 · Universitas Putra Indonesia YPTK Padang
                    </p>

                    <div className="participant-section">
                    <h3 className="info-name">{successData?.namaLengkap}</h3>
                    <p className="info-team">{successData?.namaTim}</p>
                    </div>
                </div>
                </div>

                <div className="button-area">
                <Button className="btn-apple-confirm" onClick={downloadIdCard}>
                    Download ID Card
                </Button>
                </div>
            </ModalBody>
      </Modal>



      {/* Loading Overlay */}
      {(isSubmitting || isEmailSending || isCheckingHP) && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          {isEmailSending }
          {isCheckingHP }
        </div>
      )}
    </Container>
  );
};

export default Registration;
